@if (form) {
  <form class="action-form astral-stack-m" (ngSubmit)="onSubmit()">
    <astral-form>
      <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
        <astral-date-picker [control]="form.controls['paymentDate']"></astral-date-picker>
        <app-money-box [control]="form.controls['amount']"></app-money-box>
      </astral-layout-group>
    </astral-form>
    <div class="astral-form-actions">
      <astral-button variant="primary" type="submit" [label]="'OK'"></astral-button>
      <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
    </div>
  </form>
}
